"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var _default = (0, _keyMirror.default)({
  STAGE_FOR_EDIT: null,
  CHANGE_PROPERTY: null,
  ADD_TO_MAP: null,
  REMOVE_FROM_MAP: null,
  REORDER_MAP: null,
  RESET_ALL_CHANGES: null,
  RESET_STAGED_OBJECT_CHANGES: null
});

exports.default = _default;
module.exports = exports.default;